import flagus from "../Assets/Images/flags/us.svg";
import flagturkey from "../Assets/Images/flags/tr.svg";

const languages = {
  tr: {
    label: "Türkçe",
    flag: flagturkey,
  },
  en: {
    label: "English",
    flag: flagus,
  },  
}

export default languages
